import playController from './PlayController';
import storeManager from '../../store/StoreManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';

const recordingUtils = {
    recordingPositions: [],
    startUploadingTime: -1,

    setCurrentRecordingPosition() {
        var position = this.getRecordingPosition();
        var title = this.getSoundTitle();

        this.recordingPositions.push({position, title});
    },
    removeRecordingPosition() {
        if (this.recordingPositions.length > 0)
            this.recordingPositions.shift();
    },
    getCurrentRecordingPosition() {
        if (this.recordingPositions && this.recordingPositions.length > 0)
            return this.recordingPositions[this.recordingPositions.length  - 1];
        else
            return '';
    },
    getRecordingPositionWhenDataSaved(title) {
        if (title && title.indexOf('.mp3') > 0)
            title = title.replace('.mp3', '');

        if (this.recordingPositions && this.recordingPositions.length > 0) {
            var i;
            var newPositions = [];
            var currentPosition;

            for (i=0; i<this.recordingPositions.length; i++) {
                if (this.recordingPositions[i].title.indexOf(title) != -1)
                    currentPosition = this.recordingPositions[i];
                else
                    newPositions.push(this.recordingPositions[i]);
            }

            // ensure is the first item
            if (currentPosition) {
                this.recordingPositions = [currentPosition].concat(newPositions);

                return currentPosition;
            } else
                return this.recordingPositions[0];
        } else
            return '';
    },
    getRecordingPosition() {
        var position;

        if (playController.isAudioEditorAvailable()) {
            if (!playController.isAudioEditorMode())
                position = audioEditorUtils.getCurrentSlidePosition(storeManager.getState().currentSlide.model.uuid);
            else {
                var markerPosition = audioEditorUtils.getMarkerPosition();

                if (!markerPosition || markerPosition == -1)
                    position = 0;
                else
                    position = markerPosition;
            }
        } else
            position = storeManager.getState().currentSlide.model.uuid;

        return position;
    },
    getSoundTitle() {
        const currentdate = new Date();
        const monthsOfYear = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = currentdate.getMonth();
        const monthString = monthsOfYear[month];

        var minutes = currentdate.getMinutes();

        if (minutes < 10)
            minutes = '0' + minutes;

        var seconds = currentdate.getSeconds();

        if (seconds < 10)
            seconds = '0' + seconds;

        const title = `${currentdate.getDate()} ${monthString} ${currentdate.getFullYear()} - ${currentdate.getHours()}:${minutes}:${seconds}.mp3`;

        return title;
    }
};

export default recordingUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/RecordingUtils.js
 **/